import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b914268"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PageState" }
const _hoisted_2 = { class: "PageState__container" }
const _hoisted_3 = { class: "PageState__message" }
const _hoisted_4 = { class: "PageState__message message--failed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_loader, { class: "primary" }),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.loadingMessage), 1)
          ], 64))
        : (_ctx.failed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.failedMessage), 1),
              _createVNode(_component_ok_button, { onClick: _ctx.onReload }, {
                default: _withCtx(() => [
                  _createTextVNode(" Обновить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}